// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"227":"f80a626f77492888","235":"a92be3914daaac33","252":"159be200d36a36ec","437":"4690cb49f1642979","798":"4da98cf8301e16a3","844":"e9a3f21fe0c92e15","986":"51eb7064a51395a9"}[chunkId] + ".js";
};